module.exports = __webpack_public_path__ + "img/93e9332.jpg";